// Per-device theme for the patient welcome / post-op display. Controls the
// board background and base text color. Chosen on-screen via the doctor control
// panel and persisted to localStorage so it survives reloads on that display.

const STORAGE_KEY = "dc.welcomeTheme";

export const THEME_PRESETS = [
  {
    key: "teal",
    label: "เขียว",
    bg: "linear-gradient(155deg,#e9f3f4 0%,#f4f1ea 58%,#eaf4f4 100%)",
    text: "#234b50",
  },
  { key: "white", label: "ขาว", bg: "#f7f7f4", text: "#2b2b2b" },
  { key: "cream", label: "ครีม", bg: "#f5ece0", text: "#4a3b2a" },
  { key: "dark", label: "เข้ม", bg: "#1f2b2e", text: "#eef5f5" },
  { key: "blue", label: "ฟ้า", bg: "#e7eef8", text: "#1f3a5f" },
];

export const DEFAULT_THEME = {
  key: THEME_PRESETS[0].key,
  bg: THEME_PRESETS[0].bg,
  text: THEME_PRESETS[0].text,
};

export function isHexColor(v) {
  return typeof v === "string" && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v);
}

// Accept a CSS color/background for `bg` (hex, rgb(), or a gradient) and a hex
// `text`. Anything missing or malformed falls back to the default theme.
export function normalizeTheme(raw) {
  if (!raw || typeof raw !== "object") return { ...DEFAULT_THEME };
  const bgOk =
    typeof raw.bg === "string" &&
    /^(#|rgb|hsl|linear-gradient|radial-gradient)/i.test(raw.bg.trim());
  return {
    key: typeof raw.key === "string" && raw.key ? raw.key : null,
    bg: bgOk ? raw.bg.trim() : DEFAULT_THEME.bg,
    text: isHexColor(raw.text) ? raw.text : DEFAULT_THEME.text,
  };
}

export function loadTheme() {
  try {
    return normalizeTheme(JSON.parse(localStorage.getItem(STORAGE_KEY)));
  } catch (e) {
    return { ...DEFAULT_THEME };
  }
}

export function saveTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizeTheme(theme)));
  } catch (e) {
    /* ignore quota/availability errors */
  }
}
